<template>
  <loader-ring v-if="getSystemSettingsLoading"></loader-ring>
  <div v-else>
    <div class="row align-items-center justify-content-center">
      <div class="col-md-10">
        <div class="card card--no-shadow card-profile">
          <div class="card-header">
            <h3 class="font-weight-600 mb-0">
              System Settings Information
            </h3>
          </div>
          <div class="card-content">
            <div class="card-body">
              <form @submit.prevent="updateSystemSettings">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Company's Name</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="systemSetting.site_name"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Company's Email</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="systemSetting.site_email"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Company's Phone</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="systemSetting.site_phone"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Login Email Frequency</label>
                      <select
                        v-model="systemSetting.login_email_frequency"
                        class="form-control"
                      >
                        <option value="all">Every login</option>
                        <option value="once_a_day">Once a day</option>
                      </select>
                    </div>
                  </div>
                  <!-- <div class="col-md-12">
                    <div class="form-group">
                      <label for="">Company's Address</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="systemSetting.company_address"
                        placeholder=""
                      />
                    </div>
                  </div> -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Card Funding Charge</label>
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Card Funding Charge"
                        v-model="systemSetting.card_funding_charge"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Card Request Charge</label>
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Card Request Charge"
                        v-model="systemSetting.card_request_charge"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Card Delivery Charge Lagos</label>
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Card Delivery Charge Lagos"
                        v-model="systemSetting.card_delivery_charge_lagos"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Card Delivery Charge Outside Lagos</label>
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Card Delivery Charge Outside Lagos"
                        v-model="
                          systemSetting.card_delivery_charge_outside_lagos
                        "
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Airtime Terminal Commission</label>
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Airtime Terminal Commission"
                        v-model="systemSetting.airitme_terminal_commision"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">TV Terminal Commission</label>
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="TV Terminal Commission"
                        v-model="systemSetting.tv_terminal_commision"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Power Terminal Commission</label>
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Power Terminal Commission"
                        v-model="systemSetting.power_terminal_commision"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Referral Bonus</label>
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Referral Bonus"
                        v-model="systemSetting.referral_bonus"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Data Terminal Commission</label>
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Data Terminal Commission"
                        v-model="systemSetting.data_terminal_commision"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for=""
                        >Instant Loan Application Due Date Charge Rate</label
                      >
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Instant Loan Application Due Date Charge Rate"
                        v-model="
                          systemSetting.instant_loan_application_due_date_charge_rate
                        "
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Loan Disbursement GL Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.loan_disbursement_gl_account"
                        placeholder="GL Account"
                      />
                      <!-- <select
                        name=""
                        id=""
                        v-model="systemSetting.loan_disbursement_gl_account"
                        class="form-control form-select fw-two"
                      >
                        <option value="">Please Select GL Account</option>
                        <option
                          :value="item.account_number"
                          v-for="(item, index) in gls"
                          :key="index"
                        >
                          {{ `${item.account_name} - ${item.account_number}` }}
                        </option>
                      </select> -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Loan Settlement GL Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.loan_settlement_gl_account"
                        placeholder="GL Account"
                      />
                      <!-- <select
                        name=""
                        id=""
                        v-model="systemSetting.loan_settlement_gl_account"
                        class="form-control form-select fw-two"
                      >
                        <option value="">Please Select GL Account</option>
                        <option
                          :value="item.account_number"
                          v-for="(item, index) in gls"
                          :key="index"
                        >
                          {{ `${item.account_name} - ${item.account_number}` }}
                        </option>
                      </select> -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Nanoloan Income Sweep</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.nano_loan_income_sweep_enabled"
                        class="form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Nanoloan Interest Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.nano_loan_interest_account"
                        placeholder="GL Account"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Nanoloan Charges Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.nano_loan_charges_account"
                        placeholder="GL Account"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for=""
                        >Instant Loan Application Interest Rate</label
                      >
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="instant loan application interest rate"
                        v-model="
                          systemSetting.instant_loan_application_interest_rate
                        "
                      />
                    </div>
                  </div>

                  <div class=" col-md-6">
                    <div class="form-group">
                      <label for="">Instant Loan Application Fee</label>

                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Instant Loan Application fee"
                        @keypress="isNumber($event)"
                        v-model="
                          systemSetting.instant_loan_application_application_fee
                        "
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for=""
                        >Instant Loan Application Interest Tenure</label
                      >
                      <input
                        type="text"
                        class=" form-control"
                        placeholder="Instant Loan Application Interest Tenure"
                        v-model="
                          systemSetting.instant_loan_application_interest_tenure
                        "
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Instant Loan Application Status</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.instant_loan_application_status"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Mdignit Switch</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.midnight_lock"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Transfer Switch</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.allow_transfer"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Bill Switch</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.allow_bills_payment"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Instant Loan Application Message</label>
                      <textarea
                        name=""
                        id=""
                        cols="30"
                        rows="3"
                        style="resize: none"
                        class=" form-control"
                        v-model="
                          systemSetting.instant_loan_application_status_message
                        "
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Bill GL Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.bill_gl_account"
                        placeholder="GL Account"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Card Delivery Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.card_delivery_account"
                        placeholder="GL Account"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Verifiction Method</label>
                      <select
                        name=""
                        id=""
                        class=" form-control fw-two form-select"
                        v-model="systemSetting.verification_method"
                      >
                        <option value="" selected disabled
                          >Please Select a Method</option
                        >
                        <option value="default_bvn">Default BVN</option>
                        <option value="identity_pass">Identity Pass</option>
                        <option value="igree">Igree</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Create Account</label>
                      <select
                        name=""
                        class="form-select"
                        id=""
                        v-model="systemSetting.create_account"
                      >
                        <option value="" selected disabled
                          >Please Select Mode</option
                        >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Create Account Message</label>
                      <textarea
                        name=""
                        id=""
                        cols="30"
                        rows="3"
                        style="resize: none"
                        class=" form-control"
                        v-model="systemSetting.create_account_message"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Maintenance Mode</label>
                      <select
                        name=""
                        class="form-select"
                        id=""
                        v-model="systemSetting.maintenance_mode"
                      >
                        <option value="" selected disabled
                          >Please Select Mode</option
                        >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Maintenance Mode Message</label>
                      <textarea
                        name=""
                        id=""
                        cols="30"
                        rows="3"
                        style="resize: none"
                        class=" form-control"
                        v-model="systemSetting.maintenance_mode_message"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Maintenance Mode Users</label>
                      <textarea
                        name=""
                        id=""
                        cols="30"
                        rows="3"
                        style="resize: none"
                        class=" form-control"
                        v-model="systemSetting.maintenance_mode_users"
                      ></textarea>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">First KYC Level</label>
                      <select
                        id="select"
                        class="form-select fw-two form-control"
                        v-model="systemSetting.level_1_kyc"
                      >
                        <option
                          v-for="level in customerLevels"
                          :value="level.id"
                          :selected="level.id === systemSetting.level_1_kyc"
                          :key="level.id"
                          >{{ level.name }}</option
                        >
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Second KYC Level</label>
                      <select
                        id="select"
                        class="form-select fw-two form-control"
                        v-model="systemSetting.level_2_kyc"
                      >
                        <option
                          v-for="level in customerLevels"
                          :value="level.id"
                          :selected="level.id === systemSetting.level_2_kyc"
                          :key="level.id"
                          >{{ level.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Third KYC Level</label>
                      <select
                        id="select"
                        class="form-select fw-two form-control"
                        v-model="systemSetting.level_3_kyc"
                      >
                        <option
                          v-for="level in customerLevels"
                          :value="level.id"
                          :selected="level.id === systemSetting.level_3_kyc"
                          :key="level.id"
                          >{{ level.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">BVN Validation Channel</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.bvn_verification_channel"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >
                        <option value="prembly">Prembly</option>
                        <option value="youverify">Youverify</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Test BVNs</label>
                      <textarea
                        class="form-control"
                        rows="3"
                        style="resize: none"
                        v-model="systemSetting.test_bnvs"
                        placeholder="22237138895,22237138896"
                      ></textarea>
                      <small class="text-muted">
                        Comma-separated BVNs that can be reused for testing and
                        are skipped from duplicate BVN checks.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">NIN Validation Channel</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.nin_verification_channel"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >
                        <option value="prembly">Prembly</option>
                        <option value="youverify">Youverify</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Credit Check Channel</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.credit_check_channel"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >
                        <option value="prembly">Prembly</option>
                        <option value="mono">Mono</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Loan Offer Version</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.loan_offer_version"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >                        
                        <option value="v1">V1</option>
                        <option value="v2">V2</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Customer Transfer Channel</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.customer_transfer_channel"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >                        
                        <option value="core-banking">Core Banking</option>
                        <option value="easypay">Easypay</option>
                        <option value="phlex">Phlex</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Core Banking Transfer Channel</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.core_banking_transfer_provider"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >                        
                        <option value="stanbic">Stanbic</option>
                        <option value="etransact">Etransact</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Terminal Transfer Channel</label>
                      <select
                        name=""
                        id=""
                        v-model="systemSetting.terminal_transfer_channel"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Please Status</option
                        >
                        <option value="phlex">Phlex</option>
                        <option value="core-banking">Core Banking</option>
                        <option value="easypay">Easypay</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Credit Check Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.credit_check_account"
                        placeholder="Credit Check Account"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Credit Check Charge</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.credit_check_charge"
                        placeholder="Check Check Charge"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">POS Outward Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.pos_outward_account"
                        placeholder="POS Outward Account"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">POS Deposit Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.pos_deposit_account"
                        placeholder="POS Deposit Account"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">POS Deposit Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.pos_deposit_account"
                        placeholder="POS Deposit Account"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">POS Settlement Charge</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.pos_settlement_charge"
                        placeholder="POS Settlement Charge"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Kiddies Card Request Charge</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.kiddies_card_request_charge"
                        placeholder="Kiddies Card Request Charge"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Kiddies Card Request Account</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class=" form-control"
                        v-model="systemSetting.kiddies_card_charge_account"
                        placeholder="Kiddies Card Request Account"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Kiddies Min Age</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.kiddies_min_age"
                        placeholder="8"
                      />
                      <small class="text-muted">
                        Minimum age for kids card onboarding.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Kiddies Max Age</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.kiddies_max_age"
                        placeholder="17"
                      />
                      <small class="text-muted">
                        Maximum age for kids card onboarding.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <h4 class="font-weight-600 mt-3 mb-3">
                      Provider Balance Display
                    </h4>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="">Display Account Numbers</label>
                      <textarea
                        class="form-control"
                        rows="2"
                        v-model="systemSetting.provider_balance_accounts"
                        placeholder="1300000170,1300000171,1300000172"
                      ></textarea>
                      <small class="text-muted">
                        Comma-separated account numbers shown on the Provider
                        Balances page. This is for display only and does not
                        change disbursement, repayment, or POS posting accounts.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <h4 class="font-weight-600 mt-3 mb-3">
                      Account Balance Rules
                    </h4>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Account Minimum Balance (₦)</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.account_minimum_balance"
                        placeholder="500"
                      />
                      <small class="text-muted">
                        Customers cannot initiate transfers or bill payments that
                        would leave their account below this amount.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <h4 class="font-weight-600 mt-3 mb-3">
                      Transfer Hold Fraud Detection
                    </h4>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Transfer Hold Enabled</label>
                      <select
                        class="form-control"
                        v-model="systemSetting.transfer_hold_enabled"
                      >
                        <option value="" selected disabled>Please Status</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">New Account Days</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_new_account_days"
                        placeholder="14"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Large Inflow Amount</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_large_inflow_amount"
                        placeholder="500000"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Pass Through Minutes</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_pass_through_minutes"
                        placeholder="15"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Pass Through Ratio (%)</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_pass_through_ratio"
                        placeholder="80"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Pass Through / Round-Trip Min Amount</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_pass_through_min_amount"
                        placeholder="50000"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Burst Window Minutes</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_burst_window_minutes"
                        placeholder="30"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Burst Min Debits</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_burst_min_debits"
                        placeholder="3"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Burst Min Total</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_burst_min_total"
                        placeholder="100000"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Shared Recipient Min Senders</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_shared_recipient_min_senders"
                        placeholder="3"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Shared Recipient Window Days</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_shared_recipient_window_days"
                        placeholder="7"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Inflow Burst Min Credits</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_inflow_burst_min_credits"
                        placeholder="5"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Inflow Burst Window Minutes</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_inflow_burst_window_minutes"
                        placeholder="10"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Same Source Inflow Min Credits</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_inflow_same_source_min"
                        placeholder="4"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Transfer Hold Telegram Enabled</label>
                      <select
                        class="form-control"
                        v-model="systemSetting.transfer_hold_telegram_enabled"
                      >
                        <option value="" selected disabled>Please Status</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Release Max Hours</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_release_max_hours"
                        placeholder="72"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Exclude Approved Instant Loan Customers</label>
                      <select
                        class="form-control"
                        v-model="systemSetting.transfer_hold_exclude_approved_instant_loan_customers"
                      >
                        <option value="" selected disabled>Please Status</option>
                        <option value="yes">Yes — skip transfer holds</option>
                        <option value="no">No — apply transfer holds</option>
                      </select>
                      <small class="text-muted">
                        When enabled, customers with an approved instant loan
                        (awaiting disbursement, active, or overdue) are not
                        subject to transfer hold checks.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">First-Party Inflow Bypass</label>
                      <select
                        class="form-control"
                        v-model="systemSetting.transfer_hold_first_party_bypass_enabled"
                      >
                        <option value="" selected disabled>Please Status</option>
                        <option value="yes">Yes — allow transfers after self-funding</option>
                        <option value="no">No — keep holds blocking</option>
                      </select>
                      <small class="text-muted">
                        When the latest successful inflow sender name fuzzy-matches
                        the customer, Rapid pass-through and Round-trip holds are
                        not placed and do not block transfers.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">First-Party Name Match Percent</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_first_party_match_percent"
                        placeholder="60"
                      />
                      <small class="text-muted">
                        Minimum token overlap (0–100) between sender name and
                        account holder name. Default 60.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">First-Party Inflow Categories</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="systemSetting.transfer_hold_first_party_categories"
                        placeholder="inter-bank-inflow"
                      />
                      <small class="text-muted">
                        Comma-separated credit categories that can qualify as
                        first-party (e.g. inter-bank-inflow). Virtual-account
                        inflows should usually be excluded.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2">
                    <h4 class="font-weight-600 mb-0">App Rating</h4>
                    <small class="text-muted">
                      Controls the in-app rating prompt on the mobile app.
                    </small>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Enable App Rating</label>
                      <select
                        class="form-control"
                        v-model="systemSetting.rate_app_enabled"
                      >
                        <option value="" selected disabled>Please Status</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                      <small class="text-muted">
                        Master switch. When off, the rating prompt is hidden on both platforms.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Enable On Android</label>
                      <select
                        class="form-control"
                        v-model="systemSetting.rate_app_android_enabled"
                      >
                        <option value="" selected disabled>Please Status</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Enable On iOS</label>
                      <select
                        class="form-control"
                        v-model="systemSetting.rate_app_ios_enabled"
                      >
                        <option value="" selected disabled>Please Status</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Show After Successful Transaction</label>
                      <select
                        class="form-control"
                        v-model="systemSetting.rate_app_show_on_transaction"
                      >
                        <option value="" selected disabled>Please Status</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Show Again On Next Login</label>
                      <select
                        class="form-control"
                        v-model="systemSetting.rate_app_show_on_login"
                      >
                        <option value="" selected disabled>Please Status</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                      <small class="text-muted">
                        After the customer taps Not yet, ask again on the next login.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Max Not Yet Prompts</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.rate_app_max_not_yet"
                        placeholder="5"
                      />
                      <small class="text-muted">
                        How many Not yet taps still schedule another login prompt. Default 5.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Minimum Stars For Store Review</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.rate_app_positive_min_stars"
                        placeholder="3"
                      />
                      <small class="text-muted">
                        Stars at or above this open the store. 1 to 5. Default 3.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Prompt Delay (ms)</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.rate_app_prompt_delay_ms"
                        placeholder="800"
                      />
                      <small class="text-muted">
                        Wait time before the prompt on the transaction success screen.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Cooldown (days)</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="systemSetting.rate_app_cooldown_days"
                        placeholder="30"
                      />
                      <small class="text-muted">
                        After a rating or Not yet, hide the transaction prompt for this many days. 0 shows it on every success.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Android Store URL</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="systemSetting.rate_app_android_store_url"
                        placeholder="https://play.google.com/store/apps/details?id=com.capitalmetriq.app"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">iOS Store URL</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="systemSetting.rate_app_ios_store_url"
                        placeholder="https://apps.apple.com/app/id..."
                      />
                      <small class="text-muted">
                        Used when the native iOS review sheet is unavailable. Leave empty to fall back to an App Store search.
                      </small>
                    </div>
                  </div>
                  <!-- <div class="col-md-6">
                    <div class="form-group">
                      <label for="interest_pa">Auto Save Interest p.a.</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="systemSetting.auto_save_interest_pa"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="interest_pa"
                        >Auto Save Minimum Duration</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="
                          systemSetting.auto_save_minimum_duration
                        "
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="interest_pa">Auto Save Debit Trial</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="systemSetting.auto_save_no_debit_trial"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="interest_pa"
                        >Property Save Interest p.a.</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="systemSetting.property_save_interest_pa"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="interest_pa"
                        >Property Save Minimum Amount</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="
                          systemSetting.property_save_minimum_amount
                        "
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="interest_pa">Property Save Commission</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="systemSetting.property_save_commission"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="interest_pa"
                        >Property Save Minimum Duration</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="
                          systemSetting.property_save_minimum_duration
                        "
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="interest_pa">Target Save Interest p.a.</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="systemSetting.target_interest_pa"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="interest_pa"
                        >Target Save Minimum Amount</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="
                          systemSetting.target_save_minimum_amount
                        "
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="interest_pa"
                        >Target Save Minimum Duration</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="
                          systemSetting.target_save_minimum_duration
                        "
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Commission Withdrawal Limit</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="
                          systemSetting.commission_withdrawal_limit
                        "
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Transaction Referral Count</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="
                          systemSetting.transaction_referral_count
                        "
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Transaction Referral Commission</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="
                          systemSetting.transaction_referral_commission
                        "
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Transfer Range 1 - 5000</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="systemSetting.transfer_range_1_5000"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Transfer Range 5001 - 50000</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="systemSetting.transfer_range_5001_50000"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Transfer Range 50000</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.number="systemSetting.transfer_range_50000"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Company's Facebook</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="systemSetting.facebook_link"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Company's Instagram</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="systemSetting.instagram_link"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Company's Twitter</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="systemSetting.twitter_link"
                        placeholder=""
                      />
                    </div>
                  </div> -->
                </div>
                <button
                  v-if="permissions.includes('update-settings')"
                  type="submit"
                  class="button"
                  :disabled="updateSystemSettingsLoading"
                >
                  <span
                    class="custom-loader"
                    v-if="updateSystemSettingsLoading"
                  >
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial;"
                      >Updating System Settings...</span
                    >
                  </span>
                  <span v-else>Save Changes</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <two-factor-prompt
      :visible="showTwoFaPrompt"
      :loading="updateSystemSettingsLoading"
      description="Enter your authenticator code to confirm system settings update."
      submit-label="Save Changes"
      loading-text="Updating System Settings..."
      @close="showTwoFaPrompt = false"
      @submit="confirmUpdateSystemSettings"
    />
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import Swal from "sweetalert2";
import ErrorService from "@/services/error.service";

export default {
  name: "SystemSettings",
  data() {
    return {
      getSystemSettingsLoading: false,
      updateSystemSettingsLoading: false,
      systemSetting: {},
      customerLevels: [],
      getCustomerLevelLoading: false,
      gls: [],
      showTwoFaPrompt: false
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    isNumber: function(evt) {
      console.log(evt.key);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    async getCharges() {
      try {
        this.pageLoading = true;
        const response = await ApiService.get("settings/gls");
        console.log(response.data);

        this.gls = response.data.data;
        this.pageLoading = false;
      } catch (error) {
        console.log(error.response);
        this.pageLoading = false;
      }
    },
    async getCustomerLevels() {
      try {
        this.getCustomerLevelLoading = true;

        const response = await ApiService.get("settings/kyc-levels");
        this.customerLevels = response.data.data;
        this.getCustomerLevelLoading = false;
      } catch (error) {
        this.getCustomerLevelLoading = false;
        console.log(error.response);
      }
    },
    async getSystemSettings() {
      try {
        this.getSystemSettingsLoading = true;
        const response = await ApiService.get("settings");
        console.log(response);
        this.getSystemSettingsLoading = false;
        this.systemSetting = response.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    updateSystemSettings() {
      this.showTwoFaPrompt = true;
    },
    async confirmUpdateSystemSettings(code) {
      try {
        this.updateSystemSettingsLoading = true;
        const response = await ApiService.post(
          "settings/update-settings",
          {
            ...this.systemSetting,
            code
          }
        );

        this.updateSystemSettingsLoading = false;
        this.showTwoFaPrompt = false;
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        setTimeout(() => this.getSystemSettings(), 3000);
      } catch (error) {
        console.log(error.response);
        this.updateSystemSettingsLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    }
  },
  mounted() {
    if (this.can("kyc-levels")) {
      this.getCustomerLevels();
    }
    this.getSystemSettings();
    if (this.can("gls")) {
      this.getCharges();
    }
  }
};
</script>

<style></style>
